import { useBridge as useFunnowBridge } from '@myfunnow/web-core/bridge'

import type { BridgeAction } from '@/types/js-bridge'

export function useBridge() {
  const { userAgent } = useDevice()

  return useFunnowBridge<BridgeAction>(userAgent)
}
